import React, { useState } from 'react';
import TestingMenuWrapper from './style';

const TestingMenu = ({
  campaign,
  user,
  toNextStage,
  toPrevStage,
  stage,
  vocationOne,
  vocationJunior
}) => {
  const rut = user ? user.rut : 'anon';
  const stageName = `userStage-${rut}-${campaign.id}`;
  const ItemIndex = `itemIndex-${rut}-${campaign.id}`;
  const valuesKey = `itemValues-${rut}-${campaign.id}`;
  const studyItemIndex = `studyItemsIndex-${rut}-${campaign.id}`;
  const studyValuesKey = `studyItemsValues-${rut}-${campaign.id}`;

  const [open, setOpen] = useState(false);
  const clearState = () => {
    localStorage.clear();
  };
  const reloadPage = () => {
    window.location.reload();
  };
  const clearX1Index = () => {
    localStorage.setItem(ItemIndex, 0);
  };
  const clearX1Values = () => {
    localStorage.setItem(valuesKey, JSON.stringify([]));
  };
  const clearX2Index = () => {
    localStorage.setItem(studyItemIndex, 0);
  };
  const clearX2Values = () => {
    localStorage.setItem(studyValuesKey, JSON.stringify([]));
  };
  const prevStage = () => toPrevStage(stageName);

  const nextStage = () => toNextStage(stageName);

  return (
    <TestingMenuWrapper open={open}>
      <div className='toggle'>
        <button onClick={() => setOpen(!open)}>{open ? '>' : '<'}</button>
      </div>
      <div className='options'>
        <button onClick={clearState}>Clear State</button>
        <button onClick={reloadPage}>Recargar Página</button>
        {vocationOne && (
          <React.Fragment>
            <button disabled>Vocation One Rankings</button>
            <div className='x1-nav'>
              <button onClick={clearX1Index}>Clear Index</button>
              <button onClick={clearX1Values}>Clear Values</button>
            </div>
          </React.Fragment>
        )}
        {vocationJunior && (
          <React.Fragment>
            <button disabled>Vocation Junior Rankings</button>
            <div className='x1-nav'>
              <button onClick={clearX2Index}>Clear Index</button>
              <button onClick={clearX2Values}>Clear Values</button>
            </div>
          </React.Fragment>
        )}
        <div className='stage-nav'>
          <button onClick={prevStage}>Prev Stage</button>
          <button disabled className='middle'>
            {stage}
          </button>
          <button onClick={nextStage}>Next Stage</button>
        </div>
      </div>
    </TestingMenuWrapper>
  );
};

export default TestingMenu;
